import React from 'react';
import { Box, Text } from '@mantine/core';

const ExternalSourceTab = ({ selectedLineId }) => {
  return (
    <Box p="md">
      <Text>External Source tab content for Line {selectedLineId} - to be implemented</Text>
    </Box>
  );
};

export default ExternalSourceTab;